import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { hasAnalyticsConsent } from "@/lib/analytics/consent";

const firebaseConfig = {
    apiKey: "AIzaSyDyLGjDMwJA-QxJ9GGz4SEh7qV_mGZlxTc",
    authDomain: "auth.aiinterviewagents.com",
    projectId: "ai-interview-agents",
    storageBucket: "ai-interview-agents.firebasestorage.app",
    messagingSenderId: "393448148475",
    appId: "1:393448148475:web:fe22c9741b692da8d04f5e",
    measurementId: "G-2NMV3H8KX4"
};

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
setPersistence(auth, browserLocalPersistence);
const db = getFirestore(firebaseApp);
const provider = new GoogleAuthProvider();
async function getClientAnalytics() {
    if (typeof window === "undefined" || !hasAnalyticsConsent()) return null

    // dynamic import avoids server side import errors
    const analyticsModule = await import("firebase/analytics")
    // isSupported is async and will resolve false in unsupported envs
    const supported = await analyticsModule.isSupported()
    if (!supported || !hasAnalyticsConsent()) return null

    try {
        return analyticsModule.getAnalytics(firebaseApp)
    } catch (err) {
        // initialization failed, return null
        return null
    }
} export { firebaseApp, auth, provider, db, getClientAnalytics };
